import React, { useEffect } from 'react'
import { Form, Row, Space, Button, Input, Radio, Col, message } from 'antd';

const { TextArea } = Input;

const SoftwareForm = (props) => {

    const {
        loading,
        CatalogUso,
        CatalogTipoDominio,
        editarSoftware,
        onSave,
        onCancel,
    } = props;

    const [form] = Form.useForm();

    useEffect(() => {
        if (editarSoftware) {
            form.setFieldsValue(editarSoftware);
        }
    }, [editarSoftware]);

    const onSaveForm = async () => {
        try {
            await form.validateFields();
            await onSave(form.getFieldsValue());
        } catch (e) {
            message.error("Completa los campos correctamente");
        }
    }

    return (
        <>
            <Form
                form={form}
                layout="vertical"
                onFinish={onSaveForm}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Software"
                            name="software"
                            rules={[{ required: true }, { whitespace: true }, { min: 3 }, { max: 50 }]}
                        >
                            <Input type="text" placeholder='Ingrese el nombre del software ej: Excel, Word, Powerpoint, Adobe' />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Nivel de dominio"
                            name="nivel_dominio"
                            rules={[{ required: true }]}
                        >
                            <Radio.Group options={CatalogTipoDominio} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="¿Cuentas con una certificación oficial ?"
                            name="certificacion"
                            rules={[{ required: true }]}
                        >
                            <Radio.Group options={
                                [
                                    { value: true, label: 'Si' },
                                    { value: false, label: 'No' },
                                ]}
                                onChange={(e) => form.setFieldsValue({ certificadora: null })} />
                        </Form.Item>
                    </Col>
                    <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.certificacion !== currentValues.certificacion}
                    >
                        {({ getFieldValue }) =>
                            getFieldValue('certificacion') ? (
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="Certificación"
                                        name="certificadora"
                                        rules={[{ required: true }, { whitespace: true }, { min: 3 }, { max: 50 }]}
                                    >
                                        <Input type="text" placeholder='Ingrese el nombre de la certificación' />
                                    </Form.Item>
                                </Col>
                            ) : null
                        }
                    </Form.Item>
                    <Col span={24}>
                        <Form.Item
                            label="Nivel de uso"
                            name="nivel_uso"
                            rules={[{ required: true }]}
                        >
                            <Radio.Group options={CatalogUso} />
                        </Form.Item>
                    </Col>
                    <Col span={24} >
                        <Form.Item
                            label="Aplicación"
                            name="aplicacion"
                            rules={[{ whitespace: true }, { min: 3 }, { max: 300 }]}
                        >
                            <TextArea rows={3} placeholder='¿Dónde y cómo usas esta herramienta de software? ' />
                        </Form.Item>
                    </Col>
                </Row>

                <Row justify="end">
                    <Space >
                        <Button
                            loading={loading}
                            type="primary"
                            htmlType="submit"
                        >
                            {editarSoftware ? "Guardar cambios" : "Agregar"}
                        </Button>
                        <Button
                            loading={loading}
                            onClick={() => {
                                onCancel();
                                form.resetFields();
                            }}>
                            Cancelar
                        </Button>
                    </Space>
                </Row>
            </Form>
        </>
    )
}
export default SoftwareForm;